import { create } from 'zustand';
import { creditApi } from '../api';
import { ICurrentPlanFeatures } from './creditTypes';
import { ENVIRONMENT } from 'shared/config';

type CreditState = {
  credits: number;
  maxCredits: number;
  creditsError: string | null;
  planFeatures: ICurrentPlanFeatures | undefined;
  isFree: boolean;
  isInactivePlan: boolean;
  isBasePlan: boolean;
};

type CreditActions = {
  fetchCredits: () => void;
  updateCreditStore: (key: string, value: any) => void;
  toggleBuyCreditsModal: () => void;
  toggleUpgradeModal: () => void;
  toggleFeatureBlockModal: (open: boolean | typeof features[number]) => void;
  toggleInactivePlanModal: () => void;
};

export const features = [
  'express',
  'pro',
  'agents',
  'extraCredits',
  'api',
  'premiumVoices',
  'speech',
  'chatGpt',
  'createAvatar'
] as const;

export type CreditStore = CreditState & CreditActions;

export const creditStore = create<CreditStore>()((set) => ({
  credits: 0,
  maxCredits: 0,
  creditsError: null,
  estimatedVideoPrice: null,
  planFeatures: undefined,
  isInactivePlan: false,
  isFree: false,
  isBasePlan: false,
  toggleUpgradeModal: () => {},
  toggleBuyCreditsModal: () => {},
  toggleFeatureBlockModal: () => {},
  toggleInactivePlanModal: () => {},
  updateCreditStore: (key, value) => {
    set({ [key]: value });
  },
  fetchCredits: () => {}
}));
